import React from 'react';
import axios from 'axios';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class NewSP3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nextCycleEnrollmentPossibility: this.props.nextCycleEnrollmentPossibility,
            professionalStatus: this.props.professionalStatus,
            additionalInformation: this.props.additionalInformation,
            nextCycleEnrollmentPossibilityEng: this.props.nextCycleEnrollmentPossibilityEng,
            professionalStatusEng: this.props.professionalStatusEng,
            additionalInformationEng: this.props.additionalInformationEng
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.step4 = this.step4.bind(this);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    step4() {
        this.props.step4(
            this.state.nextCycleEnrollmentPossibility,
            this.state.professionalStatus,
            this.state.additionalInformation,
            this.state.nextCycleEnrollmentPossibilityEng,
            this.state.professionalStatusEng,
            this.state.additionalInformationEng,
        );
    }

    previousStep() {
        const step = 2;
        this.props.previousStep(step);
    }


    render() {
        return (
            <div>
                <Header as="h1">Kreiranje implementacije smjera (studijskog programa)</Header>

                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Ostali podaci o smjeru (studijskom programu)
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Mogućnost upisa na sljedeći ciklus</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.nextCycleEnrollmentPossibility}
                                        onChange={(e) => this.setState({ nextCycleEnrollmentPossibility: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Mogućnost upisa na sljedeći ciklus</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.nextCycleEnrollmentPossibilityEng}
                                        onChange={(e) => this.setState({ nextCycleEnrollmentPossibilityEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Profesionalni status</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.professionalStatus}
                                        onChange={(e) => this.setState({ professionalStatus: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Profesionalni status</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.professionalStatusEng}
                                        onChange={(e) => this.setState({ professionalStatusEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Dodatne informacije</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.additionalInformation}
                                        onChange={(e) => this.setState({ additionalInformation: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Dodatne informacije</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.additionalInformationEng}
                                        onChange={(e) => this.setState({ additionalInformationEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment clearing>
                        <Button
                            color="blue"
                            basic="true"
                            onClick={this.previousStep}
                        >Nazad</Button>
                        <Button
                            color="blue"
                            floated="right"
                            onClick={this.step4}
                        >Dalje</Button>

                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}

export default NewSP3;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/NewSP3.js